import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import useSectionDarkMode from "../../hooks/useSectionDarkMode";

/** Banner cookie — chỉ gọi callback; Home mới commit preferences + cookie ngôn ngữ */
const Cookies = ({ onAcceptAll, onRejectAll, onPreferences }) => {
  const { t } = useTranslation();
  const darkMode = useSectionDarkMode("bottom");
  const bannerRef = useRef(null);

  // Ghi chiều cao banner → CSS var để Chat/Zalo đẩy lên, tránh đè banner
  useEffect(() => {
    const el = bannerRef.current;
    if (!el) return undefined;

    const syncHeight = () => {
      document.documentElement.style.setProperty(
        "--cookie-banner-h",
        `${el.offsetHeight}px`
      );
    };
    syncHeight();

    const observer = new ResizeObserver(syncHeight);
    observer.observe(el);

    return () => {
      observer.disconnect();
      document.documentElement.style.setProperty("--cookie-banner-h", "0px");
    };
  }, []);

  return (
    <div
      ref={bannerRef}
      className={`
        fixed bottom-0 left-0 right-0 z-[850]
        p-[1%] transition-colors duration-300
        backdrop-blur-[30px]
        border-t border-white/10
        ${
          darkMode
            ? "bg-white/20 text-neutral-13"
            : "bg-white/20 text-neutral-1"
        }
      `}
    >
      <div className="mx-auto flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
        <div className="leading-relaxed">
          <p className="text-[16px] font-bold">{t("cookies.title")}</p>
          <p
            className={`text-[15px] mt-1 ${
              darkMode ? "text-neutral-13/80" : "text-neutral-1/90"
            }`}
          >
            {t("cookies.description")}
          </p>
        </div>

        <div className="flex flex-col gap-2 sm:flex-row sm:items-center whitespace-nowrap">
          <button
            onClick={onPreferences}
            className={`
      p-[10px] w-full sm:w-[200px] h-[48px]
      rounded-md border text-[15px] font-normal
      flex items-center justify-center
      transition-all
      ${
        darkMode
          ? "border-neutral-13/20 text-neutral-13 hover:bg-neutral-13/10"
          : "border-neutral-1/30 text-neutral-1 hover:bg-white/10"
      }
    `}
          >
            {t("cookies.preferences")}
          </button>

          <button
            onClick={() => onRejectAll?.()}
            className={`
      p-[10px] w-full sm:w-[200px] h-[48px]
      rounded-md border text-[15px] font-normal
      flex items-center justify-center
      transition-all
      ${
        darkMode
          ? "border-neutral-13/20 text-neutral-13 hover:bg-neutral-13/10"
          : "border-neutral-1/30 text-neutral-1 hover:bg-white/10"
      }
    `}
          >
            {t("cookies.rejectAll")}
          </button>

          <button
            onClick={() => onAcceptAll?.()}
            className={`
      p-[10px] w-full sm:w-[200px] h-[48px]
      rounded-md text-[15px] font-normal
      flex items-center justify-center
      transition-all
      bg-brandBlue-500 hover:bg-brandBlue-600 text-white
    `}
          >
            {t("cookies.acceptAll")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Cookies;
